import React, { FC } from 'react';
import * as S from './styled';
import planet from './img/planet.png';

export interface Props {
	name: string;
	text: string;
	img: string;
}

export const Slide: FC<Props> = props => {
	const { name, text, img } = props;

	return (
		<S.Slide>
			<S.Header>
				<S.Avatar src={img} alt={name} />
				<S.UserName>
					<h4>{name}</h4>
					<p>
						<img src={planet} alt='planet' />
						recomends &nbsp;<span>Verv</span>
					</p>
				</S.UserName>
			</S.Header>
			<S.Review>{text}</S.Review>
		</S.Slide>
	);
};
